import { Card, Col, Row } from 'antd';
import './style.less';

const data = [
  {
    title: 'Entrance',
    bestDirections: 'North, North-NorthEast, NorthEast',
    severity: 'High (most important rule)',
    summary: 'North, North-NorthEast, NorthEast are preferred directions.',
  },
  {
    title: 'Living Room/Hall',
    bestDirections: 'NorthEast, East, South, West, North',
    severity: 'Medium (important but less critical than Entrance)',
    summary: 'NorthEast, East, South, West, North are preferred directions.',
  },
  {
    title: 'Kitchen Location',
    bestDirections: 'SouthEast, South-SouthEast, South, East',
    severity: 'High (crucial for energy flow)',
    summary:
      'SouthEast, South-SouthEast, South, East are preferred directions.',
  },
  {
    title: 'Kitchen Facing',
    bestDirections: 'South, East, West',
    severity: 'High (less critical compared to location)',
    summary: 'South, East, West are preferred directions.',
  },
  {
    title: 'Bedroom',
    bestDirections: 'SouthWest, West-SouthWest, South, West',
    severity: 'High (important for rest and relaxation)',
    summary: 'SouthWest, West-SouthWest, South, West are preferred directions.',
  },
  {
    title: 'Bed Location',
    bestDirections: 'West, West-SouthWest, South',
    severity: 'Medium (less critical than bedroom placement)',
    summary: 'West, West-SouthWest, South are preferred directions.',
  },
  {
    title: 'Bed Facing',
    bestDirections: 'South, East, SouthEast',
    severity: 'Medium (essential for restful sleep)',
    summary: 'South, East, SouthEast are preferred directions.',
  },
  {
    title: 'Bathroom',
    bestDirections: 'NorthWest, North-NorthWest, West',
    severity: 'Medium (not as critical as other areas)',
    summary: 'NorthWest, North-NorthWest, West are preferred directions.',
  },
  {
    title: 'Commode Location',
    bestDirections: 'North, North-NorthEast, South',
    severity: 'Medium (important for hygiene, but less critical)',
    summary: 'North, North-NorthEast, South are preferred directions.',
  },
  {
    title: 'Commode Facing',
    bestDirections: 'North, South',
    severity: 'Medium (important for comfort)',
    summary: 'North, South are preferred directions.',
  },
];
const Guidelines = () => {
  return (
    <div className="guideline">
      <div className="sub-guideline-container">
        <div className="title-lg medium guide-line-heading">
          Vastu Guidelines :
        </div>
        <div className="guidelines-container">
          <Row gutter={[16, 16]} justify="center">
            {data.map((item, index) => (
              <Col xs={24} sm={24} md={24} lg={24} key={index}>
                <Card
                  title={item.title}
                  bordered={true}
                  className="guideline-card"
                >
                  <p>
                    <strong>Best Directions:</strong> {item.bestDirections}
                  </p>
                  <p>
                    <strong>Vastu Importance:</strong> {item.severity}
                  </p>
                  <p>
                    <strong>Summary:</strong> {item.summary}
                  </p>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Guidelines;
